import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue';
import { getLegalDocumentUrl } from '@fr/constants';
import { nameFilterSerpStore } from '@ve/components/searchFilters/store/getFiltersSerpStore';
import { useState } from 'vuex-composition-helpers';
import { NAMESPACE as EMPTY_SEARCH_STORE } from '@ve/components/emptySearch/common/store/EmptySearchStore';
import { IEmptySearchState } from '@ve/components/emptySearch/common/store/types/IEmptySearchStore';
import { type IMapForFiltersSerpState } from '@ve/components/searchFilters/store/types';
import { LeadBanner } from '@travelata-libs/ui-shared';
import { useLeadForm } from '@entities/lead';
import { useWindowSize } from '@vueuse/core';
import { TypoVariant } from '@travelata-libs/ui-kit';
import { useTourProductsRepository } from '@fr/fsd/entities/tourProduct';
import { usePortalAnchor } from '@shared/lib';
import {
    LEAD_BANNER_TOP_PORTAL_TARGET,
    LEAD_BANNER_CARDS_PORTAL_TARGET,
    LEAD_BANNER_BOTTOM_PORTAL_TARGET,
} from '../constants';
    type VisibleType = 'top' | 'bottom' | 'card';
    type BannerConfig = Record<VisibleType, { title: string; subtitle: string; portalTarget: string }>;
    
export default /*#__PURE__*/_defineComponent({
  __name: 'SerpLeadBanner',
  emits: ["visible"],
  setup(__props, { emit }: { emit: ({(e: 'visible', type: VisibleType | null): void}), expose: any, slots: any, attrs: any }) {

const DEFAULT_TITLE = 'Не нашли подходящий отель?';
    const DEFAULT_SUBTITLE = 'Эксперт подберёт варианты — есть предложения не из выдачи';
    const BANNER_CONFIG: BannerConfig = {
        top: { title: DEFAULT_TITLE, subtitle: DEFAULT_SUBTITLE, portalTarget: LEAD_BANNER_TOP_PORTAL_TARGET },
        bottom: { title: DEFAULT_TITLE, subtitle: DEFAULT_SUBTITLE, portalTarget: LEAD_BANNER_BOTTOM_PORTAL_TARGET },
        card: { title: 'Подбираете отель?', subtitle: 'Наши сотрудники помогут найти лучший вариант', portalTarget: LEAD_BANNER_CARDS_PORTAL_TARGET },
    };
    const { syncHotels, loadingState, filteredHotels } = useState<IMapForFiltersSerpState>(nameFilterSerpStore, ['syncHotels', 'loadingState', 'filteredHotels']);
    const { currentState } = useState<IEmptySearchState>(EMPTY_SEARCH_STORE, ['currentState']);
    const { tourProducts } = useTourProductsRepository();
    const { width } = useWindowSize();
    const { 
        formRef, 
        isSubmitted, 
        onSubmit, 
        model,
        loading,
    } = useLeadForm();
    const visibleType = ref<VisibleType | null>(null);

    

    const { anchorPosition, resetAnchor } = usePortalAnchor('lead-banner', formRef);

    const title = computed(() => visibleType.value ? BANNER_CONFIG[visibleType.value].title : '');
    const subtitle = computed(() => ({
        text: visibleType.value ? BANNER_CONFIG[visibleType.value].subtitle : '',
        variant: width.value >= 1440 ? TypoVariant.BodyXLRegular : undefined,
    }));
    const portalTarget = computed(() => visibleType.value ? BANNER_CONFIG[visibleType.value].portalTarget : '');
    const isBannerVisible = computed(() => {
        if (visibleType.value === 'card') {
            return !!anchorPosition.value;
        }
        return !!visibleType.value;
    })

    const reset = () => {
        visibleType.value = null;
        resetAnchor();
    }

    watch([currentState, loadingState, syncHotels, filteredHotels, tourProducts], ([currentState, loadingState, hotels, filteredHotels, tourProducts]) => {
        const userSearch = currentState === 'userSearch' || currentState === 'userSearchHasTours';
        const alternativeSearch = !userSearch;
        if (tourProducts.length === 0) {
            reset();
        }
    
        if (loadingState === 'finished' && hotels.length === 0 || alternativeSearch && hotels.length > 0) {
            visibleType.value = 'top';
        }

        if (userSearch && loadingState === 'finished' && hotels.length > 0 && hotels.length < 3) {
            visibleType.value = 'bottom';
        }

        if (userSearch && hotels.length >= 3) {
            visibleType.value = 'card';
            if (filteredHotels.length < 3) {
                visibleType.value = null;
            }
        }
        emit('visible', visibleType.value);
    });


return { __sfc: true,DEFAULT_TITLE, DEFAULT_SUBTITLE, BANNER_CONFIG, syncHotels, loadingState, filteredHotels, currentState, tourProducts, width, formRef, isSubmitted, onSubmit, model, loading, visibleType, emit, anchorPosition, resetAnchor, title, subtitle, portalTarget, isBannerVisible, reset, getLegalDocumentUrl, LeadBanner }
}

})